import { Params } from '@angular/router';
import { AlarmDetails } from '../alarms/component-models/alarm-details';
export class ServicesState {
  alarm: AlarmDetails;
  lastRoute: Route;
}

export class Route {
  url: string;
  params?: Params;
}
